
import React from 'react';
import { Carousel } from 'antd';
import { Button, Container, Typography, Grid, Card, TextField, Box, Stack, useTheme, useMediaQuery } from '@mui/material';
import Typewriter from 'typewriter-effect';
import CustomButton from '../CustomButton';
import dashbord from '../../assets/images/header_image.png';

const items = [
  {
    key: '1',
    title: 'La solution de billetterie idéale pour votre ',
    content:
      'Proposez la meilleure expérience de billetterie en ligne, de marketing evenementiel et controle d\'acces a vous et votre public, avec Choptonticket',
  },
];

function AppHero() {
  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container>
      <div id="hero" className="heroBlock">
        {items.map((item) => (
          <div key={item.key} className="container-fluid">
            <Stack sx={{ height: "100vh" }} paddingX={{ sm: '5%' }} justifyContent={'center'} alignItems={'center'} >
              <Typography textAlign={'center'} color="black" paddingTop={10} fontSize={isMobile ? '40px' : '90px'} fontWeight={800} sx={{ lineHeight: 1 }}
              >
                
                {item.title} <span style={{color:'#5E17EB'}}><Typewriter
                  options={{
                    loop: true
                  }}
                  onInit={(typewriter) => {
                    typewriter
                      .typeString('Concert')
                      .pauseFor(1000)
                      .deleteAll()
                      .typeString('Festival')
                      .pauseFor(1000)
                      .deleteAll()
                      .typeString('Brunch')
                      .pauseFor(1000)
                      .deleteAll()
                      .typeString('Event sportif')
                      .pauseFor(1000)
                      .deleteAll()
                      .typeString('Soirée clubing')
                      .start();
                  }}
                /></span>
              </Typography>
              <Typography maxWidth={750} color="text.secondary" fontSize={isMobile ? '18px' : '22px'}  textAlign={'center'}>
                {item.content}
              </Typography>
              <Stack sx={{ width: '100%', maxWidth: 800 }} direction={isMobile ? 'column' : 'row'} spacing={2}>
                <Button
                  fullWidth
                  sx={{
                    textTransform: 'initial',
                    border: '2px solid transparent',
                    color: 'white',
                    height: 60,
                    backgroundColor: '#5E17EB',
                    boxShadow: 'none',
                    borderRadius: '7px',
                    '&:hover': {
                      backgroundColor: 'white',
                      color: '#5E17EB',
                      borderColor: '#5E17EB',
                    },
                  }}
                  variant="contained"
                  href="/bo/"
                >
                  Commencer maintenant
                </Button>
                <Button
                  fullWidth
                  sx={{
                    maxWidth: 300,
                    textTransform: 'initial',
                    border: '1px solid #f2f2f2',
                    color: 'text.primary',
                    height: 60,
                    backgroundColor: '#f2f2f23d',
                    boxShadow: 'none',
                    borderRadius: '7px',
                    '&:hover': {
                      border: '1px solid #f2f2f2',
                      color: 'text.primary',
                      backgroundColor: '#f2f2f23d',
                    },
                  }}
                  variant="contained"
                  href="/bo/"
                >
                  Demander un démo
                </Button>
              </Stack>


              {/**
             * <Box
              component="img"
              src={dashbord} // 🔄 remplace par ton image
              alt="hero background"
              sx={{
                borderRadius: '16px',
                bgcolor: 'white',
                width: "50%",
                pointerEvents: "none", // pour pas bloquer les clics
              }}
            />
             */}

            </Stack>


          </div>

        ))}


      </div>
    </Container>

  );
}

export default AppHero;
